// Shared QR style catalogue. Mirrored on the backend in server.py as
// QR_STYLE_REGISTRY / QR_SHAPE_REGISTRY — change both sides in lockstep.

export const QR_STYLES = {
  classic: {
    name: 'Classic',
    description: 'Traditional black & white',
    fgColor: '#000000',
    bgColor: 'transparent',
    level: 'M',
    includeMargin: true
  },
  cyan: {
    name: 'Cyan Glow',
    description: 'Matches KyberCosplay theme',
    fgColor: '#06b6d4',
    bgColor: 'transparent',
    level: 'M',
    includeMargin: true
  },
  fuchsia: {
    name: 'Fuchsia Pop',
    description: 'Bold magenta accent',
    fgColor: '#d946ef',
    bgColor: 'transparent',
    level: 'M',
    includeMargin: true
  },
  gradient_cyber: {
    name: 'Cyber Gradient',
    description: 'Cyan to fuchsia gradient',
    fgColor: '#06b6d4',
    bgColor: 'transparent',
    level: 'M',
    includeMargin: true,
    gradient: { from: '#06b6d4', to: '#d946ef' }
  },
  neon_green: {
    name: 'Neon Green',
    description: 'Electric green',
    fgColor: '#22c55e',
    bgColor: 'transparent',
    level: 'M',
    includeMargin: true
  },
  sunset: {
    name: 'Sunset',
    description: 'Orange to pink gradient',
    fgColor: '#f97316',
    bgColor: 'transparent',
    level: 'M',
    includeMargin: true,
    gradient: { from: '#f97316', to: '#ec4899' }
  },
  purple_haze: {
    name: 'Purple Haze',
    description: 'Deep purple vibes',
    fgColor: '#a855f7',
    bgColor: 'transparent',
    level: 'M',
    includeMargin: true
  },
  ocean: {
    name: 'Ocean',
    description: 'Blue gradient depth',
    fgColor: '#3b82f6',
    bgColor: 'transparent',
    level: 'M',
    includeMargin: true,
    gradient: { from: '#3b82f6', to: '#06b6d4' }
  },
  gold: {
    name: 'Gold',
    description: 'Luxurious gold accent',
    fgColor: '#eab308',
    bgColor: 'transparent',
    level: 'M',
    includeMargin: true
  },
  custom: {
    name: 'Custom',
    description: 'Choose your own colors',
    fgColor: '#06b6d4',
    bgColor: 'transparent',
    level: 'M',
    includeMargin: true
  }
};

// Subset that can be saved as the creator's default style. `custom` is
// excluded because it requires per-render color inputs.
export const SAVEABLE_QR_STYLE_IDS = Object.keys(QR_STYLES).filter(id => id !== 'custom');

export const DEFAULT_QR_STYLE = 'cyan';

// Module shape — qr-code-styling "dotsOptions.type" values are 'square' |
// 'dots' | 'rounded' | 'extra-rounded' | 'classy' | 'classy-rounded'.
// Backend qrcode[pil] only supports the first three natively, so we
// intersect the two sets. When you add a new shape here, also add a
// matching drawer class in server.py::QR_SHAPE_REGISTRY.
export const QR_SHAPES = [
  { id: 'square',  label: 'Square',  description: 'Classic square modules',  dotsType: 'square' },
  { id: 'dots',    label: 'Dots',    description: 'Round dot modules',       dotsType: 'dots' },
  { id: 'rounded', label: 'Rounded', description: 'Squares with soft corners', dotsType: 'rounded' },
];

export const QR_SHAPE_BY_ID = QR_SHAPES.reduce((acc, s) => {
  acc[s.id] = s;
  return acc;
}, {});

export const DEFAULT_QR_SHAPE = 'square';
